import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachegroovyComponent } from './simple-icons-apachegroovy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachegroovyComponent ],
    exports:      [ SimpleIconsApachegroovyComponent ],
    bootstrap:    []
})
export class SimpleIconsApachegroovyModule {}
